// ***NOTE*** Please preserve alphabetical order when adding new icons
export {
  faAbacus,
  // faHouse,
  faInfoCircle as faInfoCircleDuo,
  faSensorAlert,
  faSignalAlt,
  faSignalAlt1,
  faSignalAlt2,
  faSignalAlt3,
  faWifiSlash,
} from '@fortawesome/pro-duotone-svg-icons'
